import { UserSettingsInputModel } from '@ail/customers-api'
import { wrapQuery } from '../redux/api/apiQuery'
import { customersApi } from '../redux/api/customerApi'
import { AppDispatch, RootState, store } from '../redux/store'
import { FrontendSettingsKeys } from '../types/enums'
import { DEFAULT_SETTINGS, UserSettings } from '../types/constants'

export class FrontendSettings {
  public static get(key: FrontendSettingsKeys) {
    const state = store.getState() as RootState
    const old = customersApi.endpoints.getSettings.select({ remote: true })(state)
    return old.data?.[key] ?? DEFAULT_SETTINGS[key as keyof UserSettings]
  }

  public static clear(key: FrontendSettingsKeys) {
    this.set(key, undefined)
  }

  public static set(key: FrontendSettingsKeys, value: string | undefined) {
    const state = store.getState() as RootState
    const dispatch = store.dispatch as AppDispatch
    const old = customersApi.endpoints.getSettings.select({ remote: true })(state)
    const model = old.data ?? DEFAULT_SETTINGS
    const settingsEmpty = old.error && 'isApiException' in old.error && old.error.status === 404
    if (old.data || settingsEmpty)
      wrapQuery(() =>
        customersApi.endpoints.updateSettings.initiate({
          remote: true,
          model: { ...model, [key]: value ?? null } as UserSettingsInputModel,
        })
      )()(dispatch).catch(console.error)
  }

  public static getObject<T>(key: FrontendSettingsKeys): T | null | undefined {
    return this.tryParseJSON(FrontendSettings.get(key))
  }

  public static getArray<T>(key: FrontendSettingsKeys, defaultValue?: T[]): T[] {
    return this.tryParseJSON(FrontendSettings.get(key)) || defaultValue || []
  }

  public static setObject(key: FrontendSettingsKeys, object: object | unknown[]) {
    this.set(key, JSON.stringify(object))
  }

  private static tryParseJSON<T = unknown>(value: string | null | undefined): T | null | undefined {
    try {
      if (value == null) {
        return value
      }
      return JSON.parse(value)
    } catch {
      return null
    }
  }
}
